'use strict'
/* HALTE HOVER STATUS DES PARENTS, WENN MAUS INNERHALB DES DROPDOWN MENÜS */
const hoverDropdown = () => {
  let isDropdownHovered = false
  let navigationLinkParent;

  $(document).on('mouseenter', '.navigation__dropdown', function() {
    isDropdownHovered = true
    navigationLinkParent = $(this).prev('.navigation__link');
    isDropdownHovered ? navigationLinkParent.focus() : navigationLinkParent.blur();
  });

  $(document).on('mouseleave', '.navigation__dropdown', function() {
    isDropdownHovered = false
    isDropdownHovered ? navigationLinkParent.focus() : navigationLinkParent.blur();
  });
}

/* VERHINDER AUFBLITZEN DER DROPDOWN NAVIGATION */
const suppressDropdownFlash = () => {
  $(document).on('mouseover', '.navigation__item.has-children', function() {
    $(this).children('.navigation__dropdown').css('visibility', 'visible')
  })
}

$(()=>{
  hoverDropdown()
  suppressDropdownFlash()
});
